import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ModbusService} from "../../../modbusrtu/modbus.service";
import {UtilService} from "../../../shared/util.service";

@Component({
    selector: 'app-measure-dialog',
    templateUrl: './measure-dialog.component.html',
    styleUrls: ['./measure-dialog.component.scss'],
    standalone: false
})
export class MeasureDialogComponent implements OnInit {

  measure: any = {}

  constructor(
    public dialogRef: MatDialogRef<MeasureDialogComponent>,
    private util: UtilService,
    private modbusService: ModbusService,
  @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      if (this.data.measure) {
        this.measure = Object.assign({}, this.data.measure);
        if (this.measure.registers && this.measure.registers.length && this.measure.registers[3].value) {
          this.measure.neighbours = this.measure.registers[3].value;
        }
      }
    })
  }

  onModbusSelect(rtu) {
    if (rtu.loggingEnabled) {
      return;
    }
    this.measure = {
      ...this.measure,
      ...rtu
    }
  }

  handleWriteRegisters(data) {
    this.modbusService.writeMeasure(data).subscribe((resp:any) => {
      if (!resp.success) {
        this.modbusService.notiService.open("Something went wrong, check console log.");
        console.log('Error:', resp);
      } else {
        this.modbusService.notiService.open("Successful writing");

        if (resp.saved) {
          this.measure.registers = this.util.convertRawMeasureRegistersToTableData(resp.saved);
        }

        this.dialogRef.close(this.measure);
      }
    })
  }

  onSaveClick() {
    if (this.measure && this.measure.address && this.data.ip) {

      const data: any = {
        ip: this.data.ip,
        address: this.measure.address,
        length: this.measure.length,
        typemodbus: this.measure.datatypemodbus,
        index: this.data.index,
        neighbours: this.measure.neighbours,
        parent: this.data.parent,
        device: this.data.device,
      };

      // we already have registers, this is a measure thats being logged (EDIT type)
      // post the oldAddress, so we can find the register
      if (this.measure.registers && this.measure.registers.length) {
        data.type = 'edit';
        data.oldaddress = this.data.measure.address;

        // update registers
        this.measure.registers[0].value = this.measure.address;
        this.measure.registers[1].value = this.measure.datatypemodbus;
        this.measure.registers[2].value = this.measure.length;
        this.measure.registers[3].value = this.measure.neighbours;

        this.handleWriteRegisters(data);
      } else { // No registers so far, new logging
        data.type = 'add';
        this.handleWriteRegisters(data);
      }
    } else {
      this.modbusService.notiService.open("Error. Missing post data.");
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
